import React, { Component } from 'react';
import SvgIcon from '../presentation/SvgIcon';
import UserIcon from '../assets/images/svgs/user.svg';
import LogoIcon from '../assets/images/svgs/chatera-logo.svg';
import { Link } from 'react-router-dom';
import { autobind } from '../utils';
import actions from '../actions';

export default class Header extends Component {
    constructor(props) {
        super(props);
        autobind(['toggleUserOptions', 'logout'], this);
        this.state = {
            showUserOptions: false
        };
    }

    toggleUserOptions() {
        this.setState({ showUserOptions: !this.state.showUserOptions });
    }

    showChangePassword() {
        this.setState({ showUserOptions: false });
        this.props.dispatch({
            type: actions.SHOW_OVERLAY,
            overlayType: 'changepassword'
        });
    }

    logout() {
        this.setState({ showUserOptions: false });
        this.props.dispatch({ type: actions.LOGOUT });
    }

    render() {
        return (<div className="header-container hflex">
            <div className="header-content hflex jsb">
                <Link to="/" className="logo hflex">
                    {/*<img className="logo-image" src={require('../assets/images/pngs/logo.png')} />*/}
                    <SvgIcon className="logo-image" glyph={LogoIcon} width='157px' height='22px'/>
                </Link>
                <div className="user-container">
                    <div className="user-icon-container" onClick={this.toggleUserOptions}>
                        <SvgIcon glyph={UserIcon} width='34px' height='34px'/>
                    </div>
                    {this.state.showUserOptions &&
                        <ul className="custom-dropdown user-options-dropdown">
                            <li className="user-option dropdown-option" onClick={this.logout}>Logout</li>
                        </ul>
                    }
                </div>
            </div>
        </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/presentation/Header.js